import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { RequestTypes } from '../requestTypes'
import { companyKeys } from '../companyKeys'

export const useRequestCompanyChanges = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['requestChanges']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.requestChanges,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanies._def)
      queryClient.invalidateQueries(companyKeys.getCompanyDetails._def)
      options?.onSuccess?.(...args)
    },
  })
}
